/* ============================================================================
   Unmess — checkout pop-ups (sections/unmess-popups.liquid)

   One step per click on the Checkout button:
     1st click  -> Pop-up 1: cross-sell + e-book add-on strip
     2nd click  -> Pop-up 2: Pacekind + Focus Kit (adds ONLY what is missing,
                   so an item already in the cart stays at quantity 1)
     3rd click  -> checkout
   A pop-up with nothing left to offer is skipped on that same click.

   Settings arrive as JSON in window.UPU_CONFIG, set by the section. Keeping
   them out of the JavaScript source is deliberate: a merchant typo used to
   produce invalid JS, which killed the whole script and the Checkout button
   with it.
   ============================================================================ */
(function () {
  'use strict';

  /* ================================================================
     DISCOUNT MAP
     Percentages, so they convert correctly in every presentment currency:
     the price shown in the pop-up is the price charged at checkout. Each
     `pct` MUST match the matching POPUP-* code in Shopify admin.
       POPUP-KIT / POPUP-TIMER / POPUP-SOUND = 20%
     Products that are not in this map are shown and charged at full price.
  ================================================================ */
  var DISCOUNT_MAP = {
    'focus-kit':                                      { pct: 20, code: 'POPUP-KIT'   },
    'focus-timer-pomodoro-for-scattered-minds':       { pct: 20, code: 'POPUP-TIMER' },
    'unmess-sound-15-tracks-to-start-stay-and-stop':  { pct: 20, code: 'POPUP-SOUND' }
  };

  /* Matches Shopify's discount engine: the discount AMOUNT is floored per line,
     not the final price rounded. Keeps pop-up and checkout cent-for-cent equal. */
  function salePrice(cents, pct){
    var discount = Math.floor(cents * pct / 100);
    return cents - discount;
  }

  /* ================================================================
     CONFIG — every merchant-editable value arrives as JSON
  ================================================================ */
  function parseHandles(value){
    return String(value == null ? '' : value)
      .split(/[\s,]+/)
      .map(function(s){ return s.trim(); })
      .filter(Boolean);
  }

  var RAW = window.UPU_CONFIG || {};
  var RAW1 = RAW.popup1 || {};
  var RAW2 = RAW.popup2 || {};
  var RAWEB = RAW1.ebooks || {};

  var CFG = {
    popup1: {
      enabled: !!RAW1.enabled,
      handles: parseHandles(RAW1.handles),
      copy: RAW1.copy || {},
      ebooks: {
        enabled: !!RAWEB.enabled,
        title: RAWEB.title,
        add: RAWEB.add,
        added: RAWEB.added,
        handles: parseHandles(RAWEB.handles)
      }
    },
    popup2: {
      enabled: !!RAW2.enabled,
      handle: parseHandles(RAW2.handle)[0] || '',
      replace: !!RAW2.replace,
      replaces: parseHandles(RAW2.replaces),
      copy: RAW2.copy || {}
    }
  };

  /* ================================================================
     HELPERS
  ================================================================ */
  function qs(s,c){ return (c||document).querySelector(s); }

  function money(cents){
    if(window.Unmess && window.Unmess.formatMoney) return window.Unmess.formatMoney(cents);
    return '$'+(cents/100).toFixed(2);
  }

  function esc(s){
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function track(n,d){
    try{
      if(window.gtag) window.gtag('event',n,d||{});
      if(window.fbq)  window.fbq('trackCustom',n,d||{});
    }catch(e){}
  }

  /* Cart API */
  function api(url,o){
    return fetch(url, Object.assign({headers:{'Accept':'application/json'}}, o||{}))
      .then(function(r){ if(!r.ok) throw new Error(r.status); return r.json(); });
  }
  function getCart(){ return api('/cart.js'); }
  function getProd(h){ return api('/products/'+h+'.js'); }

  /* Adds one or more lines at quantity 1 each. Only ever called with items that
     are NOT already in the cart, so no existing line is ever incremented. */
  function cartAddMany(variantIds){
    return api('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items: variantIds.map(function(id){ return {id:Number(id), quantity:1}; }) })
    });
  }
  function cartAdd(vid){ return cartAddMany([vid]); }

  function cartHandles(cart){
    return ((cart && cart.items) || []).map(function(i){ return i.handle; });
  }

  function cleanEbookTitle(t){
    return String(t)
      .replace(/^\s*\[E-?BOOK\]\s*/i, '')
      .replace(/\s*[-–]\s*an UNMESS e-?Book\s*$/i, '')
      .replace(/\s*an UNMESS e-?Book\s*$/i, '')
      .trim();
  }

  /* Fetches the configured products, dropping anything already in the cart,
     unavailable or missing. Never throws to the caller. */
  function fetchMissing(handles, inCart){
    var list = (handles || []).filter(function(h){ return (inCart || []).indexOf(h) === -1; });
    if(!list.length) return Promise.resolve([]);
    return Promise.all(
      list.map(function(h){ return getProd(h).catch(function(){ return null; }); })
    ).then(function(res){
      return res.filter(function(p){ return p && p.available && p.variants && p.variants.length; });
    }).catch(function(){ return []; });
  }

  function getEbooks(inCart){
    var cfg = CFG.popup1.ebooks || {};
    if(!cfg.enabled) return Promise.resolve([]);
    return fetchMissing(cfg.handles, inCart);
  }

  function refreshUI(cart){
    document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true,detail:{cart:cart}}));
  }

  function openCartDrawer(){
    var drawer = document.querySelector('cart-drawer');
    if(drawer && typeof drawer.open === 'function'){ drawer.open(); return; }
    document.dispatchEvent(new CustomEvent('cart:open',{bubbles:true}));
  }

  function openOverlay(el){
    el.classList.add('is-open');
    el.removeAttribute('aria-hidden');
    var f = qs('button',el);
    if(f) setTimeout(function(){ f.focus(); },60);
  }
  function closeOverlay(el){
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden','true');
  }

  var ov1 = qs('#upu-overlay-1');
  var ov2 = qs('#upu-overlay-2');

  /* Dismissing a pop-up returns to the cart — it never jumps to checkout by
     accident. The next click on Checkout moves the flow forward. */
  function dismissP1(){ closeOverlay(ov1); openCartDrawer(); }
  function dismissP2(){ closeOverlay(ov2); openCartDrawer(); }

  document.addEventListener('keydown',function(e){
    if(e.key!=='Escape') return;
    if(ov1 && ov1.classList.contains('is-open')){ dismissP1(); }
    else if(ov2 && ov2.classList.contains('is-open')){ dismissP2(); }
  });
  if(ov1) ov1.addEventListener('click',function(e){ if(e.target===ov1){ dismissP1(); } });
  if(ov2) ov2.addEventListener('click',function(e){ if(e.target===ov2){ dismissP2(); } });

  /* ── Popup discount tracking ──────────────────────────────────────────────
     A discount code comes ONLY from what the customer adds inside pop-up 1 —
     never from the catalog, product pages, quick-add, the e-book strip or
     pop-up 2 (which is full price, add-only). */
  var _p1added = [];

  /* Shopify applies one discount code per order, so two cross-sell items need a
     single COMBINED code (these exist in admin). */
  var COMBO_CODES = {
    'focus-kit+focus-timer-pomodoro-for-scattered-minds': 'POPUP-KIT-TIMER',
    'focus-kit+unmess-sound-15-tracks-to-start-stay-and-stop': 'POPUP-KIT-SOUND',
    'focus-timer-pomodoro-for-scattered-minds+unmess-sound-15-tracks-to-start-stay-and-stop': 'POPUP-TIMER-SOUND'
  };

  function largestSingleCode(handles){
    var best=null, bestPct=0;
    handles.forEach(function(h){ var d=DISCOUNT_MAP[h]; if(d && d.pct>bestPct){ bestPct=d.pct; best=d.code; } });
    return best;
  }

  function popupDiscountCode(handles){
    var added = _p1added.filter(function(h){ return handles.indexOf(h)!==-1 && DISCOUNT_MAP[h]; });
    if(!added.length) return null;
    if(added.length===1) return DISCOUNT_MAP[added[0]].code;
    var key = added.slice().sort().join('+');
    return COMBO_CODES[key] || largestSingleCode(added);
  }

  /* Applies the earned code to the live cart session so the drawer total matches
     the price shown in the pop-up. Safe no-op when no code applies. */
  function applyDiscount(code){
    if(!code) return Promise.resolve();
    return fetch('/discount/'+encodeURIComponent(code), {credentials:'same-origin'})
      .catch(function(){ /* non-fatal: the checkout URL still carries the code */ });
  }

  function syncCartDiscount(){
    return getCart().then(function(cart){
      var code = popupDiscountCode(cartHandles(cart));
      if(!code) return cart;
      return applyDiscount(code).then(getCart).then(function(fresh){
        refreshUI(fresh);
        return fresh;
      });
    }).catch(function(){ /* never block the flow on a sync failure */ });
  }

  /* Always reaches checkout, even if the cart lookup fails. */
  function proceedToCheckout(){
    getCart()
      .then(function(cart){
        var code = popupDiscountCode(cartHandles(cart));
        window.location.href = code ? ('/checkout?discount='+encodeURIComponent(code)) : '/checkout';
      })
      .catch(function(){ window.location.href='/checkout'; });
  }

  /* ================================================================
     POP-UP 1 — CROSS-SELL  (1st checkout click)
  ================================================================ */
  var _p1fired = false;

  function renderP1(products, ebooks){
    var d = qs('.upu-dialog',ov1);
    var n = products.length;
    var C = CFG.popup1.copy;
    var EB = CFG.popup1.ebooks || {};

    /* E-book strip — full price, add-only. */
    var ebookHtml = '';
    if(ebooks && ebooks.length){
      var ebCards = ebooks.map(function(p){
        var v   = p.variants[0];
        var img = p.images[0] ? '<img src="'+esc(p.images[0])+'" alt="'+esc(cleanEbookTitle(p.title))+'" loading="lazy">' : '';
        var cmp = (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : null;
        var pct = cmp ? Math.round((1 - v.price / cmp) * 100) : 0;
        return [
          '<div class="upu-ebook" data-eb-handle="'+esc(p.handle)+'" data-eb-vid="'+esc(v.id)+'">',
            '<span class="upu-ebook__check"><svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="1.5,6 4.5,9 10.5,3"/></svg></span>',
            '<div class="upu-ebook__img">'+img+'</div>',
            '<p class="upu-ebook__name">'+esc(cleanEbookTitle(p.title))+'</p>',
            '<div class="upu-ebook__price">',
              '<span class="upu-ebook__current">'+money(v.price)+'</span>',
              cmp ? '<s class="upu-ebook__compare">'+money(cmp)+'</s><span class="upu-ebook__save">-'+pct+'%</span>' : '',
            '</div>',
            '<button class="upu-ebook__cta" data-eb-add>'+esc(EB.add || 'Add')+'</button>',
          '</div>'
        ].join('');
      }).join('');
      ebookHtml = [
        '<div class="upu-ebooks">',
          EB.title ? '<div class="upu-ebooks__head">'+esc(EB.title)+'</div>' : '',
          '<div class="upu-ebooks__grid">'+ebCards+'</div>',
        '</div>'
      ].join('');
    }

    var cards = products.map(function(p){
      var v    = p.variants[0];
      var disc = DISCOUNT_MAP[p.handle];
      var origCents = v.price;
      var saleCents = disc ? salePrice(origCents, disc.pct) : origCents;
      var cmpCents = disc ? origCents : ((v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : null);
      var pct  = disc ? disc.pct : (cmpCents ? Math.round((1 - v.price / cmpCents) * 100) : 0);
      var img  = p.images[0] ? '<img src="'+esc(p.images[0])+'" alt="'+esc(p.title)+'" loading="lazy">' : '';
      var msg  = disc ? 'Only '+money(saleCents)+' before checkout' : '';
      return [
        '<div class="upu-card" data-handle="'+esc(p.handle)+'" data-vid="'+esc(v.id)+'">',
          '<span class="upu-card__check"><svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="1.5,6 4.5,9 10.5,3"/></svg></span>',
          '<div class="upu-card__img">'+img+'</div>',
          '<div class="upu-card__info">',
            '<p class="upu-card__name">'+esc(p.title)+'</p>',
            '<div class="upu-card__price">',
              '<span class="upu-card__current">'+money(saleCents)+'</span>',
              cmpCents ? '<s class="upu-card__compare">'+money(cmpCents)+'</s><span class="upu-card__save">-'+pct+'%</span>' : '',
            '</div>',
            msg ? '<p class="upu-card__msg">'+msg+'</p>' : '',
          '</div>',
          '<button class="upu-card__cta" data-add>'+esc(C.add)+'</button>',
        '</div>'
      ].join('');
    }).join('');

    d.innerHTML = [
      '<button class="upu-close" aria-label="Close" data-close><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M2 2l12 12M14 2L2 14"/></svg></button>',
      '<div class="upu-header">',
        '<div class="upu-badge"><span class="upu-badge-dot"></span>'+esc(C.badge)+'</div>',
        '<h2 class="upu-title">'+esc(n>1?C.titleN:C.title1)+'</h2>',
        '<p class="upu-subtitle">'+esc(C.subtitle)+'</p>',
      '</div>',
      '<div class="upu-body">',
        n ? '<div class="upu-products upu-products--'+n+'">'+cards+'</div>' : '',
        ebookHtml,
        '<div class="upu-actions">',
          '<button class="upu-btn-viewcart" data-continue>'+esc(C.viewCart || 'View cart')+'</button>',
          '<button class="upu-btn-secondary" data-nothanks>'+esc(C.noThanks)+'</button>',
        '</div>',
        '<p class="upu-note">'+esc(C.note)+'</p>',
      '</div>'
    ].join('');

    /* Every way out of pop-up 1 closes it and returns to the cart. The next
       click on Checkout opens pop-up 2. */
    qs('[data-close]',d).addEventListener('click',function(){ track('upu_p1_dismissed'); dismissP1(); });
    qs('[data-continue]',d).addEventListener('click',function(){ track('upu_p1_continue');  dismissP1(); });
    qs('[data-nothanks]',d).addEventListener('click',function(){ track('upu_p1_nothanks');  dismissP1(); });

    d.querySelectorAll('[data-add]').forEach(function(btn){
      btn.addEventListener('click',function(){
        if(btn.disabled) return;
        var card = btn.closest('.upu-card');
        var vid  = card.dataset.vid, hdl = card.dataset.handle;
        btn.disabled=true; btn.textContent='...'; card.classList.add('is-busy');
        cartAdd(vid)
          .then(getCart)
          .then(function(cart){
            refreshUI(cart);
            card.classList.remove('is-busy'); card.classList.add('is-added');
            btn.textContent=C.added; btn.classList.add('is-added');
            if(_p1added.indexOf(hdl)===-1) _p1added.push(hdl);
            track('upu_p1_item_added',{handle:hdl,variant_id:vid});
            return syncCartDiscount();
          })
          .catch(function(){
            card.classList.remove('is-busy');
            btn.disabled=false; btn.textContent='Try again';
          });
      });
    });

    /* E-books: add-only, deliberately outside the discount logic. */
    d.querySelectorAll('[data-eb-add]').forEach(function(btn){
      btn.addEventListener('click',function(){
        if(btn.disabled) return;
        var card = btn.closest('.upu-ebook');
        var vid  = card.dataset.ebVid, hdl = card.dataset.ebHandle;
        btn.disabled=true; btn.textContent='...'; card.classList.add('is-busy');
        cartAdd(vid)
          .then(getCart)
          .then(function(cart){
            refreshUI(cart);
            card.classList.remove('is-busy'); card.classList.add('is-added');
            btn.textContent = EB.added || 'Added'; btn.classList.add('is-added');
            track('upu_p1_ebook_added',{handle:hdl,variant_id:vid});
          })
          .catch(function(){
            card.classList.remove('is-busy');
            btn.disabled=false; btn.textContent = EB.add || 'Add';
          });
      });
    });

    openOverlay(ov1);
    track('upu_p1_opened');
  }

  /* Resolves true when pop-up 1 was shown, false when there was nothing to show. */
  function tryShowP1(cart){
    if(!CFG.popup1.enabled || _p1fired || !ov1) return Promise.resolve(false);
    var inCart = cartHandles(cart);
    return Promise.all([
      fetchMissing(CFG.popup1.handles.slice(0,3), inCart),
      getEbooks(inCart)
    ]).then(function(res){
      var products = res[0], ebooks = res[1];
      if(!products.length && !ebooks.length) return false;
      _p1fired = true;
      renderP1(products, ebooks);
      return true;
    }).catch(function(){ return false; });
  }

  /* ================================================================
     POP-UP 2 — THE BUNDLE  (2nd checkout click)

     One single product (Focus KIT + Pacekind by Unmess). It is not shown at
     all when that product is already in the cart, and the add button re-reads
     the cart before adding, so an existing line can never reach quantity 2.

     Because the bundle already contains its component products, taking it
     removes those components from the cart, so the same thing is never paid
     for twice. That replacement is a theme setting and can be switched off.
  ================================================================ */
  var _p2fired = false;

  /* Sets the listed handles to quantity 0. Never rejects: on failure the cart
     is returned unchanged rather than blocking the checkout. */
  function cartRemove(cart, handles){
    var updates = {}, removed = [];
    ((cart && cart.items) || []).forEach(function(item){
      if(handles.indexOf(item.handle) !== -1){
        updates[item.variant_id] = 0;
        removed.push(item.handle);
      }
    });
    if(!removed.length) return Promise.resolve(cart);
    return api('/cart/update.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ updates: updates })
    }).then(function(fresh){
      track('upu_p2_components_removed',{handles:removed});
      return fresh;
    }).catch(function(){ return cart; });
  }

  function renderP2(product){
    var d = qs('.upu-dialog',ov2);
    var C = CFG.popup2.copy;
    var v = product.variants[0];
    var cmp = (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : null;
    var pct = cmp ? Math.round((1 - v.price / cmp) * 100) : 0;
    var img = product.images[0] ? '<img src="'+esc(product.images[0])+'" alt="'+esc(product.title)+'" loading="lazy">' : '';
    var ctaLabel = C.cta || 'Add to cart';

    d.innerHTML = [
      '<button class="upu-close" aria-label="Close" data-close2><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M2 2l12 12M14 2L2 14"/></svg></button>',
      '<div class="upu-header">',
        '<div class="upu-badge"><span class="upu-badge-dot"></span>'+esc(C.badge)+'</div>',
        '<h2 class="upu-title">'+esc(C.title)+'</h2>',
        '<p class="upu-subtitle">'+esc(C.subtitle)+'</p>',
      '</div>',
      '<div class="upu-body">',
        img ? '<div class="upu-bundle-img">'+img+'</div>' : '',
        '<p class="upu-bundle-name">'+esc(product.title)+'</p>',
        '<p class="upu-bundle-price">'+money(v.price)+(cmp ? '<s>'+money(cmp)+'</s>' : '')+(cmp ? '<span class="upu-card__save">-'+pct+'%</span>' : '')+'</p>',
        '<div class="upu-actions">',
          '<button class="upu-btn-primary" data-p2-add>'+esc(ctaLabel)+'</button>',
          '<button class="upu-btn-secondary" data-p2-skip>'+esc(C.btnSkip)+'</button>',
        '</div>',
        (CFG.popup2.replace && C.replacing) ? '<p class="upu-removing-note">'+esc(C.replacing)+'</p>' : '',
        C.note ? '<p class="upu-note">'+esc(C.note)+'</p>' : '',
      '</div>'
    ].join('');

    qs('[data-close2]',d).addEventListener('click',function(){ track('upu_p2_dismissed'); dismissP2(); });
    qs('[data-p2-skip]',d).addEventListener('click',function(){
      closeOverlay(ov2); track('upu_p2_skipped'); proceedToCheckout();
    });

    qs('[data-p2-add]',d).addEventListener('click',function(){
      var btn = qs('[data-p2-add]',d);
      if(btn.disabled) return;
      btn.disabled = true; btn.textContent = '...';
      getCart()
        .then(function(cart){
          /* Already in the cart (another tab, a double click): do not add again. */
          if(cartHandles(cart).indexOf(product.handle) !== -1) return cart;
          return cartAddMany([v.id]).then(getCart);
        })
        .then(function(cart){
          if(!CFG.popup2.replace || !CFG.popup2.replaces.length) return cart;
          return cartRemove(cart, CFG.popup2.replaces);
        })
        .then(function(cart){
          refreshUI(cart);
          track('upu_p2_bundle_added',{handle:product.handle,variant_id:v.id});
          closeOverlay(ov2);
          proceedToCheckout();
        })
        .catch(function(){
          btn.disabled = false; btn.textContent = ctaLabel;
        });
    });

    openOverlay(ov2);
    track('upu_p2_opened');
  }

  /* Resolves true when pop-up 2 was shown, false when there is nothing to offer. */
  function tryShowP2(cart){
    if(!CFG.popup2.enabled || _p2fired || !ov2) return Promise.resolve(false);
    var handle = CFG.popup2.handle;
    if(!handle) return Promise.resolve(false);
    if(cartHandles(cart).indexOf(handle) !== -1) return Promise.resolve(false); // already taken
    return getProd(handle).then(function(product){
      if(!product || !product.available || !product.variants || !product.variants.length) return false;
      _p2fired = true;
      renderP2(product);
      return true;
    }).catch(function(){ return false; });
  }

  /* ================================================================
     ENTRY POINT — one step per click on Checkout
  ================================================================ */
  var _busy = false;

  function beforeCheckout(){
    try {
      if(_busy) return;
      _busy = true;
      getCart()
        .then(function(cart){
          return tryShowP1(cart).then(function(shown){
            if(shown) return true;
            return tryShowP2(cart);
          });
        })
        .then(function(shown){
          _busy = false;
          if(!shown) proceedToCheckout();
        })
        .catch(function(){ _busy = false; proceedToCheckout(); });
    } catch(e){
      _busy = false;
      proceedToCheckout();
    }
  }

  window.UPU_beforeCheckout = beforeCheckout;

})();
